import { useCallback, useEffect, useState } from "react"

import { Flex, Segmented, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import ReactJson from "react-json-view"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import Icon from "../../../../Icon"
import useColorJsonKeys, { getJsonViewTheme } from "../../../User/hooks/useColorJsonKeys"
import Creators from "../reducer"
import WebhookAttemptsTable from "./WebhookAttemptsTable"

import "./eventDetails.less"

const { Text } = Typography

const webhookAttemptsFilterOptions = [
  { label: "All", value: "all" },
  { label: "Succeeded", value: "succeeded" },
  { label: "Failed", value: "failed" }
]

const EventDetailsPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { event_id } = useParams()

  //hook for custom changing color of some key's values in react-json-view
  useColorJsonKeys({
    id: "#DF7000"
  })

  const { eventData, filterWebhookAttempts } = useSelector((state) => state.publicApi)
  const isDark = useSelector((state) => state.nav?.theme) === "dark"
  const payload = eventData?.payload || {}
  const rawLogs = eventData?.attempts || []
  const firstLog = rawLogs[0] || {}

  const normalizedCurrentEventData = {
    id: eventData?.id,
    event_type: eventData?.event_type || firstLog?.event_type,
    status: eventData?.status || firstLog?.status,
    source_id: payload?.alert_id || null,
    external_event_id: payload?.event_id || eventData?.id,
    payload
  }

  const current_event_data = normalizedCurrentEventData
  const eventDetailsPayload = payload
  const filteredLogs = rawLogs.filter((log) => {
    if (filterWebhookAttempts === "all") return true
    if (filterWebhookAttempts === "succeeded") return log?.status === "sent"
    if (filterWebhookAttempts === "failed") return log?.status === "failed"
    return true
  })
  const webhookAttempts = filteredLogs.map((log, index) => ({
    id: log?.id,
    status: log?.status,
    endpoint_name: log?.endpoint_name,
    attempt: index + 1,
    response_status: log?.response_status,
    response_body: log?.response_body,
    error_message: log?.error_message,
    sent_at: log?.sent_at,
    created: log?.created || log?.sent_at,
    event_type: log?.event_type
  }))

  // console.log('filterWebhookAttempts', filterWebhookAttempts)

  const [isCollapsed, setIsCollapsed] = useState(true)

  const collapsedCountLines = 15

  const countLines = (obj) => {
    const jsonString = JSON.stringify(obj, null, 2)
    return jsonString.split("\n").length
  }
  const totalLines = countLines(eventDetailsPayload)

  //for table Webhook attempts
  // const pageSize = 10;
  // const [pageNumber, setPageNumber] = useState(1);
  const [ordering, setOrdering] = useState(null)

  const updateData = (ordering, filterWebhookAttempts) => {
    const data = {
      ordering,
      event_id
    }
    dispatch(Creators.getEventRequest({ ...data }))
  }

  const handleChangeFilter = useCallback((newData) => {
    console.log("filterWebhookAttempts", newData)
    dispatch(Creators.publicApiSetProp("filterWebhookAttempts", newData))
    // setPageNumber(1)
  }, [])

  useEffect(() => {
    updateData(ordering, filterWebhookAttempts)
  }, [event_id, ordering, filterWebhookAttempts])

  return (
    <div className="event-details-page">
      <div className="header" style={{ marginBottom: 23 }}>
        <Flex
          gap={6}
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/developers/webhooks", { state: { fromEventDetails: true } })}
        >
          <Icon type="arrow_left2" />
          <Text type="secondary">{t("Go back")}</Text>
        </Flex>
        <Flex justify="space-between">
          <Text style={{ display: "block", fontWeight: 600, fontSize: 18, margin: "10px 0 4px" }}>
            {current_event_data?.event_type}
          </Text>
        </Flex>
        <Text type="secondary">
          {`Event ID: ${current_event_data?.external_event_id || current_event_data?.id}`}
        </Text>

        <Text style={{ display: "block", fontWeight: 600, fontSize: 16, margin: "21px 0 12px" }}>
          {t("Event data")}
        </Text>
      </div>

      <div
        className={cls("json-wrapper-events", {
          "full-view": !isCollapsed || totalLines <= collapsedCountLines
        })}
      >
        <ReactJson
          src={eventDetailsPayload || {}}
          name={null}
          displayArrayKey={false}
          displayDataTypes={false}
          displayObjectSize={false}
          enableClipboard={false}
          collapsed={false}
          theme={getJsonViewTheme(isDark)}
          // iconStyle={''}
          // showComma={true}
        />
        {totalLines <= collapsedCountLines ? null : (
          <>
            <div className="gradient-overlay" />
            <div onClick={() => setIsCollapsed(!isCollapsed)} className="total-lines">
              {isCollapsed ? `Load all ${totalLines} lines` : "View less"}
              <Icon
                type="arrow_select_down"
                style={!isCollapsed ? { transform: "rotate(180deg" } : null}
              />
            </div>
          </>
        )}
      </div>

      <Flex align="center" justify="space-between">
        <div>
          <Text style={{ display: "block", fontWeight: 600, fontSize: 16, margin: "21px 0 6px" }}>
            {t("Webhook attempts")}
          </Text>
          <Text type="secondary">
            {t("Attempts to send this event to your webhook endpoints in the last 15 days.")}
          </Text>
        </div>
        <div>
          <Segmented
            options={webhookAttemptsFilterOptions}
            onChange={handleChangeFilter}
            value={filterWebhookAttempts}
          />
        </div>
      </Flex>

      <WebhookAttemptsTable attempts={webhookAttempts} onOrderingChange={setOrdering} />

      {/* {['disable', 'expire_secret', 'delete' ].includes(modalType) &&
        <ActionModal
          modalType={modalType}
          close={()=>setModalType(null)}
          onOk={handleModalAction}
        />
      } */}
    </div>
  )
}

export default EventDetailsPage
